// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2jOXh","disabled":"FileBtn_disabled__1ad2b","warn":"FileBtn_warn__oNIms","fade":"FileBtn_fade__1Gq4Q"};